import {URL} from './Url'
// import { LoginResponse, User } from '../instances/Instances';


const LoginAuth = async (email : string, password : string) => {

  const response = await fetch(`${URL}/User/Login`, {
        method: "POST",
        headers: {
            "content-type" : "application/json"
        },
        body: JSON.stringify({
         "email" : email,
         "Password": password
        })
    })

    const data = await response.json();
    return data;
    

}

export {LoginAuth}